module.exports = __webpack_public_path__ + "img/logo@2x.31803f02.png";